import React from "react";

export const socialMediaIcons = {
  instagram: "ico_instagram2",
  facebook: "ico_facebook",
  twitter: "ico_twitter-x",
  telegram: "ico_telegram",
  bluesky: "ico_bluesky",
  tiktok: "ico_tiktok",
  linkdin: "ico_linkdin",
  pinterest: "ico_Vector-4",
  youtube: "ico_youtube",
};
export const socialMediaIcons2 = {
  instagram: "ico_instagram2",
  telegram: "ico_telegram",
  bluesky: "ico_bluesky",
  tiktok: "ico_tiktok",
  facebook: "ico_facebook",
  twitter: "ico_twitter-x",
  linkdin: "ico_linkdin",
  pinterest: "ico_Vector-4",
  youtube: "ico_youtube",
};
export const timeZoneToCountry = {
  "Africa/Abidjan": "CIV", // Côte d'Ivoire
  "Africa/Accra": "GHA", // Ghana
  "Africa/Addis_Ababa": "ETH", // Ethiopia
  "Africa/Algiers": "DZA", // Algeria
  "Africa/Asmara": "ERI", // Eritrea
  "Africa/Bamako": "MLI", // Mali
  "Africa/Bangui": "CAF", // Central African Republic
  "Africa/Banjul": "GMB", // Gambia
  "Africa/Bissau": "GNB", // Guinea-Bissau
  "Africa/Blantyre": "MWI", // Malawi
  "Africa/Brazzaville": "COG", // Republic of the Congo
  "Africa/Bujumbura": "BDI", // Burundi
  "Africa/Cairo": "EGY", // Egypt
  "Africa/Casablanca": "MAR", // Morocco
  "Africa/Conakry": "GIN", // Guinea
  "Africa/Dakar": "SEN", // Senegal
  "Africa/Dar_es_Salaam": "TZA", // Tanzania
  "Africa/Djibouti": "DJI", // Djibouti
  "Africa/Douala": "CMR", // Cameroon
  "Africa/El_Aaiun": "ESH", // Western Sahara
  "Africa/Freetown": "SLE", // Sierra Leone
  "Africa/Gaborone": "BWA", // Botswana
  "Africa/Harare": "ZWE", // Zimbabwe
  "Africa/Johannesburg": "ZAF", // South Africa
  "Africa/Juba": "SSD", // South Sudan
  "Africa/Kampala": "UGA", // Uganda
  "Africa/Khartoum": "SDN", // Sudan
  "Africa/Kigali": "RWA", // Rwanda
  "Africa/Kinshasa": "COD", // DR Congo (Kinshasa)
  "Africa/Lagos": "NGA", // Nigeria
  "Africa/Libreville": "GAB", // Gabon
  "Africa/Lome": "TGO", // Togo
  "Africa/Luanda": "AGO", // Angola
  "Africa/Lubumbashi": "COD", // DR Congo (Lubumbashi)
  "Africa/Lusaka": "ZMB", // Zambia
  "Africa/Malabo": "GNQ", // Equatorial Guinea
  "Africa/Maputo": "MOZ", // Mozambique
  "Africa/Maseru": "LSO", // Lesotho
  "Africa/Mbabane": "SWZ", // Eswatini
  "Africa/Mogadishu": "SOM", // Somalia
  "Africa/Monrovia": "LBR", // Liberia
  "Africa/Nairobi": "KEN", // Kenya
  "Africa/Ndjamena": "TCD", // Chad
  "Africa/Niamey": "NER", // Niger
  "Africa/Nouakchott": "MRT", // Mauritania
  "Africa/Ouagadougou": "BFA", // Burkina Faso
  "Africa/Porto-Novo": "BEN", // Benin
  "Africa/Sao_Tome": "STP", // São Tomé and Príncipe
  "Africa/Tripoli": "LBY", // Libya
  "Africa/Tunis": "TUN", // Tunisia
  "Africa/Windhoek": "NAM", // Namibia
  "America/Adak": "USA", // United States (Adak, Alaska)
  "America/Anchorage": "USA", // United States (Anchorage, Alaska)
  "America/Anguilla": "AIA", // Anguilla
  "America/Antigua": "ATG", // Antigua and Barbuda
  "America/Araguaina": "BRA", // Brazil
  "America/Argentina/Buenos_Aires": "ARG", // Argentina
  "America/Argentina/Catamarca": "ARG", // Argentina
  "America/Argentina/Cordoba": "ARG", // Argentina
  "America/Argentina/Jujuy": "ARG", // Argentina
  "America/Argentina/La_Rioja": "ARG", // Argentina
  "America/Argentina/Mendoza": "ARG", // Argentina
  "America/Argentina/Rio_Gallegos": "ARG", // Argentina
  "America/Argentina/Salta": "ARG", // Argentina
  "America/Argentina/San_Juan": "ARG", // Argentina
  "America/Argentina/San_Luis": "ARG", // Argentina
  "America/Argentina/Tucuman": "ARG", // Argentina
  "America/Argentina/Ushuaia": "ARG", // Argentina
  "America/Aruba": "ABW", // Aruba
  "America/Asuncion": "PRY", // Paraguay
  "America/Atikokan": "CAN", // Canada
  "America/Bahia": "BRA", // Brazil
  "America/Bahia_Banderas": "MEX", // Mexico
  "America/Barbados": "BRB", // Barbados
  "America/Belem": "BRA", // Brazil
  "America/Belize": "BLZ", // Belize
  "America/Blanc-Sablon": "CAN", // Canada
  "America/Boa_Vista": "BRA", // Brazil
  "America/Bogota": "COL", // Colombia
  "America/Boise": "USA", // United States
  "America/Cambridge_Bay": "CAN", // Canada
  "America/Campo_Grande": "BRA", // Brazil
  "America/Cancun": "MEX", // Mexico
  "America/Caracas": "VEN", // Venezuela
  "America/Cayenne": "GUF", // French Guiana
  "America/Cayman": "CYM", // Cayman Islands
  "America/Chicago": "USA", // United States
  "America/Chihuahua": "MEX", // Mexico
  "America/Costa_Rica": "CRI", // Costa Rica
  "America/Creston": "CAN", // Canada
  "America/Cuiaba": "BRA", // Brazil
  "America/Curacao": "CUW", // Curaçao
  "America/Danmarkshavn": "GRL", // Greenland
  "America/Dawson": "CAN", // Canada
  "America/Dawson_Creek": "CAN", // Canada
  "America/Denver": "USA", // United States
  "America/Detroit": "USA", // United States
  "America/Dominica": "DMA", // Dominica
  "America/Edmonton": "CAN", // Canada
  "America/Eirunepe": "BRA", // Brazil
  "America/El_Salvador": "SLV", // El Salvador
  "America/Fort_Nelson": "CAN", // Canada
  "America/Fortaleza": "BRA", // Brazil
  "America/Glace_Bay": "CAN", // Canada
  "America/Godthab": "GRL", // Greenland
  "America/Goose_Bay": "CAN", // Canada
  "America/Grand_Turk": "TCA", // Turks and Caicos Islands
  "America/Grenada": "GRD", // Grenada
  "America/Guadeloupe": "GLP", // Guadeloupe
  "America/Guatemala": "GTM", // Guatemala
  "America/Guayaquil": "ECU", // Ecuador
  "America/Guyana": "GUY", // Guyana
  "America/Halifax": "CAN", // Canada
  "America/Havana": "CUB", // Cuba
  "America/Hermosillo": "MEX", // Mexico
  "America/Indiana/Indianapolis": "USA", // United States
  "America/Indiana/Knox": "USA", // United States
  "America/Indiana/Marengo": "USA", // United States
  "America/Indiana/Petersburg": "USA", // United States
  "America/Indiana/Tell_City": "USA", // United States
  "America/Indiana/Vevay": "USA", // United States
  "America/Indiana/Vincennes": "USA", // United States
  "America/Indiana/Winamac": "USA", // United States
  "America/Inuvik": "CAN", // Canada
  "America/Iqaluit": "CAN", // Canada
  "America/Jamaica": "JAM", // Jamaica
  "America/Juneau": "USA", // United States
  "America/Kentucky/Louisville": "USA", // United States
  "America/Kentucky/Monticello": "USA", // United States
  "America/Kralendijk": "BES", // Bonaire, Sint Eustatius, and Saba
  "America/La_Paz": "BOL", // Bolivia
  "America/Lima": "PER", // Peru
  "America/Los_Angeles": "USA", // United States
  "America/Lower_Princes": "SXM", // Sint Maarten
  "America/Maceio": "BRA", // Brazil
  "America/Managua": "NIC", // Nicaragua
  "America/Manaus": "BRA", // Brazil
  "America/Marigot": "MAF", // Saint Martin
  "America/Martinique": "MTQ", // Martinique
  "America/Matamoros": "MEX", // Mexico
  "America/Mazatlan": "MEX", // Mexico
  "America/Menominee": "USA", // United States
  "America/Merida": "MEX", // Mexico
  "America/Metlakatla": "USA", // United States
  "America/Mexico_City": "MEX", // Mexico
  "America/Miquelon": "SPM", // Saint Pierre and Miquelon
  "America/Moncton": "CAN", // Canada
  "America/Monterrey": "MEX", // Mexico
  "America/Montevideo": "URY", // Uruguay
  "America/Montreal": "CAN", // Canada
  "America/Montserrat": "MSR", // Montserrat
  "America/Nassau": "BHS", // Bahamas
  "America/New_York": "USA", // United States
  "America/Nipigon": "CAN", // Canada
  "America/Nome": "USA", // United States
  "America/Noronha": "BRA", // Brazil
  "America/North_Dakota/Beulah": "USA", // United States
  "America/North_Dakota/Center": "USA", // United States
  "America/North_Dakota/New_Salem": "USA", // United States
  "America/Ojinaga": "MEX", // Mexico
  "America/Panama": "PAN", // Panama
  "America/Pangnirtung": "CAN", // Canada
  "America/Paramaribo": "SUR", // Suriname
  "America/Phoenix": "USA", // United States
  "America/Port-au-Prince": "HTI", // Haiti
  "America/Port_of_Spain": "TTO", // Trinidad and Tobago
  "America/Porto_Velho": "BRA", // Brazil
  "America/Puerto_Rico": "PRI", // Puerto Rico
  "America/Punta_Arenas": "CHL", // Chile
  "America/Rainy_River": "CAN", // Canada
  "America/Rankin_Inlet": "CAN", // Canada
  "America/Recife": "BRA", // Brazil
  "America/Regina": "CAN", // Canada
  "America/Resolute": "CAN", // Canada
  "America/Rio_Branco": "BRA", // Brazil
  "America/Santarem": "BRA", // Brazil
  "America/Santiago": "CHL", // Chile
  "America/Santo_Domingo": "DOM", // Dominican Republic
  "America/Sao_Paulo": "BRA", // Brazil
  "America/Scoresbysund": "GRL", // Greenland
  "America/Sitka": "USA", // United States
  "America/St_Barthelemy": "BLM", // Saint Barthélemy
  "America/St_Johns": "CAN", // Canada
  "America/St_Kitts": "KNA", // Saint Kitts and Nevis
  "America/St_Lucia": "LCA", // Saint Lucia
  "America/St_Thomas": "VIR", // United States Virgin Islands
  "America/St_Vincent": "VCT", // Saint Vincent and the Grenadines
  "America/Swift_Current": "CAN", // Canada
  "America/Tegucigalpa": "HND", // Honduras
  "America/Thule": "GRL", // Greenland
  "America/Thunder_Bay": "CAN", // Canada
  "America/Tijuana": "USA", // United States
  "America/Toronto": "CAN", // Canada
  "America/Tortola": "VGB", // British Virgin Islands
  "America/Vancouver": "CAN", // Canada
  "America/Whitehorse": "CAN", // Canada
  "America/Winnipeg": "CAN", // Canada
  "America/Yakutat": "USA", // United States
  "America/Yellowknife": "CAN", // Canada
  "Antarctica/Casey": "ATA", // Antarctica
  "Antarctica/Davis": "ATA", // Antarctica
  "Antarctica/DumontDUrville": "ATA", // Antarctica
  "Antarctica/Macquarie": "ATA", // Antarctica
  "Antarctica/Mawson": "ATA", // Antarctica
  "Antarctica/McMurdo": "ATA", // Antarctica
  "Antarctica/Palmer": "ATA", // Antarctica
  "Antarctica/Rothera": "ATA", // Antarctica
  "Antarctica/Syowa": "ATA", // Antarctica
  "Antarctica/Troll": "ATA", // Antarctica
  "Antarctica/Vostok": "ATA", // Antarctica
  "Arctic/Longyearbyen": "NOR", // Norway
  "Asia/Aden": "YEM", // Yemen
  "Asia/Almaty": "KAZ", // Kazakhstan
  "Asia/Amman": "JOR", // Jordan
  "Asia/Anadyr": "RUS", // Russia
  "Asia/Aqtau": "KAZ", // Kazakhstan
  "Asia/Aqtobe": "KAZ", // Kazakhstan
  "Asia/Ashgabat": "TKM", // Turkmenistan
  "Asia/Atyrau": "KAZ", // Kazakhstan
  "Asia/Baghdad": "IRQ", // Iraq
  "Asia/Bahrain": "BHR", // Bahrain
  "Asia/Baku": "AZE", // Azerbaijan
  "Asia/Bangkok": "THA", // Thailand
  "Asia/Barnaul": "RUS", // Russia
  "Asia/Beirut": "LBN", // Lebanon
  "Asia/Bishkek": "KGZ", // Kyrgyzstan
  "Asia/Brunei": "BRN", // Brunei
  "Asia/Chita": "RUS", // Russia
  "Asia/Choibalsan": "MNG", // Mongolia
  "Asia/Colombo": "LKA", // Sri Lanka
  "Asia/Damascus": "SYR", // Syria
  "Asia/Dhaka": "BGD", // Bangladesh
  "Asia/Dili": "TLS", // Timor-Leste
  "Asia/Dubai": "ARE", // United Arab Emirates
  "Asia/Dushanbe": "TJK", // Tajikistan
  "Asia/Famagusta": "CYP", // Cyprus
  "Asia/Gaza": "PSE", // Palestine
  "Asia/Hebron": "PSE", // Palestine
  "Asia/Ho_Chi_Minh": "VNM", // Vietnam
  "Asia/Hong_Kong": "HKG", // Hong Kong
  "Asia/Hovd": "MNG", // Mongolia
  "Asia/Irkutsk": "RUS", // Russia
  "Asia/Jakarta": "IDN", // Indonesia
  "Asia/Jayapura": "IDN", // Indonesia
  "Asia/Jerusalem": "ISR", // Israel
  "Asia/Kabul": "AFG", // Afghanistan
  "Asia/Kamchatka": "RUS", // Russia
  "Asia/Karachi": "PAK", // Pakistan
  "Asia/Kathmandu": "NPL", // Nepal
  "Asia/Khandyga": "RUS", // Russia
  "Asia/Kolkata": "IND", // India
  "Asia/Calcutta": "IND",
  "Asia/Krasnoyarsk": "RUS", // Russia
  "Asia/Kuala_Lumpur": "MYS", // Malaysia
  "Asia/Kuching": "MYS", // Malaysia
  "Asia/Kuwait": "KWT", // Kuwait
  "Asia/Macau": "MAC", // Macau
  "Asia/Magadan": "RUS", // Russia
  "Asia/Makassar": "IDN", // Indonesia
  "Asia/Manila": "PHL", // Philippines
  "Asia/Muscat": "OMN", // Oman
  "Asia/Nicosia": "CYP", // Cyprus
  "Asia/Novokuznetsk": "RUS", // Russia
  "Asia/Novosibirsk": "RUS", // Russia
  "Asia/Omsk": "RUS", // Russia
  "Asia/Oral": "KAZ", // Kazakhstan
  "Asia/Phnom_Penh": "KHM", // Cambodia
  "Asia/Pontianak": "IDN", // Indonesia
  "Asia/Pyongyang": "PRK", // North Korea
  "Asia/Qatar": "QAT", // Qatar
  "Asia/Qostanay": "KAZ", // Kazakhstan
  "Asia/Qyzylorda": "KAZ", // Kazakhstan
  "Asia/Riyadh": "SAU", // Saudi Arabia
  "Asia/Sakhalin": "RUS", // Russia
  "Asia/Samarkand": "UZB", // Uzbekistan
  "Asia/Seoul": "KOR", // South Korea
  "Asia/Shanghai": "CHN", // China
  "Asia/Singapore": "SGP", // Singapore
  "Asia/Srednekolymsk": "RUS", // Russia
  "Asia/Taipei": "TWN", // Taiwan
  "Asia/Tashkent": "UZB", // Uzbekistan
  "Asia/Tbilisi": "GEO", // Georgia
  "Asia/Tehran": "IRN", // Iran
  "Asia/Thimphu": "BTN", // Bhutan
  "Asia/Tokyo": "JPN", // Japan
  "Asia/Tomsk": "RUS", // Russia
  "Asia/Ulaanbaatar": "MNG", // Mongolia
  "Asia/Urumqi": "CHN", // China
  "Asia/Ust-Nera": "RUS", // Russia
  "Asia/Vientiane": "LAO", // Laos
  "Asia/Vladivostok": "RUS", // Russia
  "Asia/Yakutsk": "RUS", // Russia
  "Asia/Yangon": "MMR", // Myanmar
  "Asia/Yekaterinburg": "RUS", // Russia
  "Asia/Yerevan": "ARM", // Armenia
  "Europe/Amsterdam": "NLD", // Netherlands
  "Europe/Andorra": "AND", // Andorra
  "Europe/Astrakhan": "RUS", // Russia
  "Europe/Athens": "GRC", // Greece
  "Europe/Belgrade": "SRB", // Serbia
  "Europe/Berlin": "DEU", // Germany
  "Europe/Bratislava": "SVK", // Slovakia
  "Europe/Brussels": "BEL", // Belgium
  "Europe/Bucharest": "ROU", // Romania
  "Europe/Budapest": "HUN", // Hungary
  "Europe/Busingen": "DEU", // Germany
  "Europe/Chisinau": "MDA", // Moldova
  "Europe/Copenhagen": "DNK", // Denmark
  "Europe/Dublin": "IRL", // Ireland
  "Europe/Gibraltar": "GIB", // Gibraltar
  "Europe/Guernsey": "GGY", // Guernsey
  "Europe/Helsinki": "FIN", // Finland
  "Europe/Isle_of_Man": "IMN", // Isle of Man
  "Europe/Istanbul": "TUR", // Turkey
  "Europe/Jersey": "JEY", // Jersey
  "Europe/Kaliningrad": "RUS", // Russia
  "Europe/Kiev": "UKR", // Ukraine
  "Europe/Kirov": "RUS", // Russia
  "Europe/Lisbon": "PRT", // Portugal
  "Europe/Ljubljana": "SVN", // Slovenia
  "Europe/London": "GBR", // United Kingdom
  "Europe/Luxembourg": "LUX", // Luxembourg
  "Europe/Madrid": "ESP", // Spain
  "Europe/Malta": "MLT", // Malta
  "Europe/Mariehamn": "ALA", // Åland Islands
  "Europe/Minsk": "BLR", // Belarus
  "Europe/Monaco": "MCO", // Monaco
  "Europe/Moscow": "RUS", // Russia
  "Europe/Oslo": "NOR", // Norway
  "Europe/Paris": "FRA", // France
  "Europe/Podgorica": "MNE", // Montenegro
  "Europe/Prague": "CZE", // Czech Republic
  "Europe/Riga": "LVA", // Latvia
  "Europe/Rome": "ITA", // Italy
  "Europe/Samara": "RUS", // Russia
  "Europe/San_Marino": "SMR", // San Marino
  "Europe/Sarajevo": "BIH", // Bosnia and Herzegovina
  "Europe/Saratov": "RUS", // Russia
  "Europe/Simferopol": "UKR", // Ukraine
  "Europe/Skopje": "MKD", // North Macedonia
  "Europe/Sofia": "BGR", // Bulgaria
  "Europe/Stockholm": "SWE", // Sweden
  "Europe/Tallinn": "EST", // Estonia
  "Europe/Tirane": "ALB", // Albania
  "Europe/Ulyanovsk": "RUS", // Russia
  "Europe/Uzhgorod": "UKR", // Ukraine
  "Europe/Vaduz": "LIE", // Liechtenstein
  "Europe/Vatican": "VAT", // Vatican City
  "Europe/Vienna": "AUT", // Austria
  "Europe/Vilnius": "LTU", // Lithuania
  "Europe/Volgograd": "RUS", // Russia
  "Europe/Warsaw": "POL", // Poland
  "Europe/Zagreb": "HRV", // Croatia
  "Europe/Zaporozhye": "UKR", // Ukraine
  "Europe/Zurich": "CHE", // Switzerland
  "Pacific/Apia": "WSM", // Samoa
  "Pacific/Auckland": "NZL", // New Zealand
  "Pacific/Bougainville": "PNG", // Papua New Guinea
  "Pacific/Chatham": "NZL", // New Zealand
  "Pacific/Chuuk": "FSM", // Micronesia
  "Pacific/Easter": "CHL", // Chile
  "Pacific/Efate": "VUT", // Vanuatu
  "Pacific/Enderbury": "KIR", // Kiribati
  "Pacific/Fakaofo": "TKL", // Tokelau
  "Pacific/Fiji": "FJI", // Fiji
  "Pacific/Funafuti": "TUV", // Tuvalu
  "Pacific/Galapagos": "ECU", // Ecuador
  "Pacific/Gambier": "PYF", // French Polynesia
  "Pacific/Guadalcanal": "SLB", // Solomon Islands
  "Pacific/Guam": "GUM", // Guam
  "Pacific/Honolulu": "USA", // United States
  "Pacific/Kanton": "KIR", // Kiribati
  "Pacific/Kiritimati": "KIR", // Kiribati
  "Pacific/Kosrae": "FSM", // Micronesia
  "Pacific/Kwajalein": "MHL", // Marshall Islands
  "Pacific/Majuro": "MHL", // Marshall Islands
  "Pacific/Marquesas": "PYF", // French Polynesia
  "Pacific/Midway": "UMI", // United States Minor Outlying Islands
  "Pacific/Nauru": "NRU", // Nauru
  "Pacific/Niue": "NIU", // Niue
  "Pacific/Norfolk": "NFK", // Norfolk Island
  "Pacific/Noumea": "NCL", // New Caledonia
  "Pacific/Pago_Pago": "ASM", // American Samoa
  "Pacific/Palau": "PLW", // Palau
  "Pacific/Pitcairn": "PCN", // Pitcairn Islands
  "Pacific/Pohnpei": "FSM", // Micronesia
  "Pacific/Port_Moresby": "PNG", // Papua New Guinea
  "Pacific/Rarotonga": "COK", // Cook Islands
  "Pacific/Saipan": "MNP", // Northern Mariana Islands
  "Pacific/Tahiti": "PYF", // French Polynesia
  "Pacific/Tarawa": "KIR", // Kiribati
  "Pacific/Tongatapu": "TON", // Tonga
  "Pacific/Wake": "UMI", // United States Minor Outlying Islands
  "Pacific/Wallis": "WLF", // Wallis and Futuna
  "Atlantic/Azores": "PRT", // Portugal
  "Atlantic/Bermuda": "BMU", // Bermuda
  "Atlantic/Canary": "ESP", // Spain
  "Atlantic/Cape_Verde": "CPV", // Cape Verde
  "Atlantic/Faroe": "FRO", // Faroe Islands
  "Atlantic/Madeira": "PRT", // Portugal
  "Atlantic/Reykjavik": "ISL", // Iceland
  "Atlantic/South_Georgia": "SGS", // South Georgia and the South Sandwich Islands
  "Atlantic/Stanley": "FLK", // Falkland Islands
  "Atlantic/St_Helena": "SHN", // Saint Helena
  "Indian/Antananarivo": "MDG", // Madagascar
  "Indian/Chagos": "IOT", // British Indian Ocean Territory
  "Indian/Christmas": "CXR", // Christmas Island
  "Indian/Cocos": "CCK", // Cocos (Keeling) Islands
  "Indian/Comoro": "COM", // Comoros
  "Indian/Kerguelen": "ATF", // French Southern and Antarctic Lands
  "Indian/Mahe": "SYC", // Seychelles
  "Indian/Maldives": "MDV", // Maldives
  "Indian/Mauritius": "MUS", // Mauritius
  "Indian/Mayotte": "MYT", // Mayotte
  "Indian/Reunion": "REU", // Réunion
};

export const defaultFormation = "4-4-2";
export const postType = {
  twitter: "twitter",
};
export const fallBackImg = "/assets/images/ipublisher.jpg";

export const typesMatchStatus = {
  notStartYet: "NYS",
  finished: "Finished",
  finishedAET: "Finished AET",
};

export const sportTypes = {
  football: "football",
  cricket: "cricket",
  tennis: "tennis",
  rugby: "rugby",
  basketball: "basketball",
};
export const IMG_URL = "https://sportcccmsbackend.6lgx.com";

// Get image base URL from data-base-url attribute (origin only, without path, removes "cms-" prefix)
export const getImgUrl = () => {
  if (typeof document === "undefined") return IMG_URL;

  const container = document.querySelector(".microservice-cont");
  const baseUrl = container?.getAttribute("data-base-url");

  if (!baseUrl) return IMG_URL;

  try {
    const url = new URL(baseUrl);
    // Remove "cms-" or "cms." prefix from hostname
    const hostname = url.hostname.replace(/^cms[-.]/, "");
    return `${url.protocol}//${hostname}`;
  } catch {
    return IMG_URL;
  }
};
